import type {
  PayerOrganizationRead,
  PayersListApiArg,
} from 'src/common/external/bambi-api/bambiApi';
import { usePayersListSelectedQuery } from 'src/common/external/bambi-api/bambiApi';

export function usePayerOrganizationOptions(
  search?: string,
  selectedPayers?: string[],
  selectedPayerId?: string,
  canMultiload?: boolean,
  payerFilters?: Partial<PayersListApiArg>
) {
  const { data, isLoading, isFetching } = usePayersListSelectedQuery({
    search,
    canMultiload,
    ...payerFilters,
    payerFilters: {
      selected_payers: selectedPayers?.length ? selectedPayers : [],
    },
    pageSize: 1000,
  });
  const payers: PayerOrganizationRead[] = data?.results || [];
  let options = payers.map((payer) => ({
    label: payer.display_name,
    value: payer.id,
  }));

  if (selectedPayerId) {
    options = options.filter((option) => option.value !== selectedPayerId);
  }

  return { options, isLoading, isFetching };
}
